(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedcontactusblock = window.oneadvanced.refreshedcontactusblock || {};
    window.oneadvanced.refreshedcontactusblock.init = function () {
        //console.log("initializing refreshedcontactusblock js.......");

        //Below code show the Marketo Form or Live Chat option on click of a button type as Phone/email or chat 
        openForm = function (e) {
            if (e.classList.contains('phone_email')) {
                var refreshedcontactusblock = e.closest('.refreshedcontactusblock');
                var isThreeSection = e.closest('.threesection');
                var c = refreshedcontactusblock.classList.contains('first-block') ? "expand-1" : isThreeSection && refreshedcontactusblock.classList.contains('last-block') ? "expand-3" : "expand-2";
                var el = e.parentElement.parentElement.parentElement.nextElementSibling;
                if (el.classList.contains('hide')) {
                    el.classList.remove("hide");
                    e.classList.remove("dropdown-down-arrow");
                    e.classList.add("dropdown-up-arrow");
                    refreshedcontactusblock.classList.add(c);
                } else {
                    el.classList.add("hide");
                    e.classList.remove("dropdown-up-arrow");
                    e.classList.add("dropdown-down-arrow");
                    refreshedcontactusblock.classList.remove(c);
                }
            }
            else {
                try {
                    qualified('open')
                }
                catch {
                    console.log("Qualified Chatbot not found on this page!!")
                }
            }
        }
    };

    window.oneadvanced.refreshedcontactusblock.hasLoaded = true;
})();